// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__1mrC6","email":"Header_email__1nB3_","avatar":"Header_avatar__2Nk21","logout":"Header_logout__10o3h"};